
<!-- them ten doanh nghiep -->
<!--Header-->
<app-landingpage-header-child [disableLogin]="true"></app-landingpage-header-child>
<!-- End Header-->
<div id="wrapper-kyc-update">
  <form name="form" #f="ngForm"
    (ngSubmit)="!f.form.valid? accordion.openAll() : 'true' && f.form.valid && onSign()" appFocusFirstElement
    [appCheckInputNumber]="['','accountNumber','certificateNo', 'representativeCertificateNo']"
    [appCheckPhone]="['phone', 'fax']">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{'update_enterprise.screen_name_new' | translate}}: {{oldEnterpriseName}}
          <!-- <small class="form-text text-gray pull-left pb-2 float-right">(<span style="color: red;">*</span>)
            {{'form.info' | translate}}</small> -->
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
                {{'title.customer_info'| translate}}
                <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                  translate}}
                </small>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <ng-container *ngIf="enterprises.parentId">
                <div style="padding: 12px;" class="col-md-9 d-flex align-items-start mb-3">
                  <small style="white-space: nowrap; width: fit-content;">{{'search_form.parent_name' |
                    translate}}</small>
                  <div class="pl-5 d-flex">
                    <div>{{enterprises.parentName}}</div>
                  </div>
                </div>
                <div class="col-md-3 d-flex align-items-center mb-3"></div>
              </ng-container>
              <!-- <div class="col-md-4">
                <small>{{'headertable.username' | translate}}</small>
                <p matTooltip="{{enterprises.adminUser}}" class="dotted fix-width">{{enterprises.adminUser}}</p>
              </div> -->
              <div class="col-md-12">
                <mat-form-field class="w-100">
                  <input (focusout)="enterprises.name = enterprises.name.trim()" #focusInput matInput type="text"
                    name="name" #name="ngModel" [(ngModel)]="enterprises.name" required maxlength="200"
                    [placeholder]="(enterprises.enterpriseType == personalId)?
                    ('form.full_name'| translate)
                    :('search_form.enterprise_name'| translate)">
                  <button mat-button *ngIf="enterprises.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="enterprises.name=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || name.invalid">
                    <span *ngIf="name?.errors?.required" class="text-error">{{(enterprises.enterpriseType == personalId?
                      'update_enterprise.enterprise_info.lbl_validation_person'
                      :'update_enterprise.enterprise_info.lbl_validation_enterprise')| translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="enterprises.enterpriseType == personalId">
                <mat-form-field class="w-100">
                  <input matInput autocomplete="off" (dateInput)="addEvent( $event)"
                    (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['birthday'])"
                    [matDatepicker]="birthday1" name="birthday" [(ngModel)]="enterprises.birthday"
                    (dateInput)="addEvent($event)" (dateChange)="addEvent($event)" maxlength="10" #birthday2="ngModel"
                    #pickerInput2 [max]="maxDate" [placeholder]="'form.birthday' | translate" />
                  <mat-datepicker-toggle matSuffix [for]="birthday1"></mat-datepicker-toggle>
                  <mat-datepicker #birthday1></mat-datepicker>
                  <mat-error *ngIf="f.submitted || birthday2.invalid">
                    {{getErrorDateMessage(pickerInput2.value)}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4" *ngIf="enterprises.enterpriseType == personalId">
                <mat-label style="color: #858796">{{'form.sex' | translate}}</mat-label><br>
                <mat-radio-group #sexSelect1 id="sex" name="sex" [(ngModel)]="enterprises.sex">
                  <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                  <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.type_certification' | translate}}</mat-label>
                  <mat-select #certificationTypeSelect (focusout)="(checkFocus = true)"
                    (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, certificationTypeSelect)" id="certificateId"
                    name="certificateId" #certificateId="ngModel" [(ngModel)]="enterprises.certificateId"
                    value="enterprises.certificateId" [disabled]="true" required>
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate"
                        [formControl]="enterprises.enterpriseType == personalId ? representativeCertificateTypeFilterCtrl : certificationTypeFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let certificate of (enterprises.enterpriseType == personalId ? filteredRepresentativeCertificateType : filteredCertificationType) | async"
                      [value]="certificate.id"
                      (click)="this.commonService.closeDropdownList(this.certificationTypeSelect)">
                      {{getEnterpriseTypeOptions(certificate.langs)}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || certificateId.invalid">
                    <span *ngIf="certificateId?.errors?.required" class="text-error">{{'validation.type_of_doc' |
                      translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input (focusout)="enterprises.certificateNo = enterprises.certificateNo.trim()" matInput type="text"
                    id="certificateCodeId" name="certificateNo" #certificateNo="ngModel"
                    [(ngModel)]="enterprises.certificateNo" required maxlength="20" appCheckSpace
                    [placeholder]="'form.certification_no' | translate" [disabled]="true">
                  <button mat-button *ngIf="enterprises.certificateNo" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.certificateNo=''" [disabled]="true">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || certificateNo.invalid">
                    <span *ngIf="certificateNo?.errors?.required" class="text-error">{{'validation.number_of_doc' |
                      translate}}
                    </span>
                    <span *ngIf="certificateNo?.errors?.validInput" class="text-error">
                      {{'validation.gpkd_format' | translate}}
                    </span>
                    <span *ngIf="certificateNo?.errors?.duplicate" class="text-error">
                      {{'update_enterprise.validation.lbl_validation_gpkd_duplicate' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input matInput autocomplete="off" [max]="maxDate" (dateInput)="addEvent($event)"
                    (dateChange)="addEvent($event)" [matDatepicker]="issuedDate1" name="issuedDate"
                    [(ngModel)]="enterprises.issuedDate" #issuedDate="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && issuedDate.invalid }" required maxlength="10"
                    #pickerInput3 [placeholder]="'form.issued_date' | translate"
                    (keyup)="checkIssuedDateChange(pickerInput3.value)" />
                  <mat-datepicker-toggle matSuffix [for]="issuedDate1"></mat-datepicker-toggle>
                  <mat-datepicker #issuedDate1></mat-datepicker>
                  <mat-error *ngIf="f.submitted || issuedDate.invalid">
                    {{getErrorDateMessage(pickerInput3.value)}}
                  </mat-error>
                  <mat-error *ngIf="f.submitted || checkIssuedDate">
                    {{'validation.issued_date' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4"
                *ngIf="enterprises.enterpriseType != personalId || enterprises.enterpriseType == null">
                <mat-form-field class="w-100">
                  <input (focusout)="enterprises.issuedAt = enterprises.issuedAt.trim()" matInput autocomplete="off"
                    type="text" name="issuedAt" #issuedAt="ngModel" [(ngModel)]="enterprises.issuedAt"
                    [ngClass]="{ 'is-invalid': f.submitted && issuedAt.invalid }" required maxlength="200"
                    [placeholder]="'form.issued_by' | translate">
                  <button mat-button *ngIf="enterprises.issuedAt" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.issuedAt=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || issuedAt.invalid">
                    <span *ngIf="issuedAt?.errors?.required" class="text-error">{{'validation.issued_by' |
                      translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4" *ngIf="enterprises.enterpriseType == personalId">
                <mat-form-field class="w-100">
                  <input (focusout)="enterprises.issuedAt = enterprises.issuedAt.trim()" matInput autocomplete="off"
                    type="text" name="issuedAt" #issuedAt="ngModel" [(ngModel)]="enterprises.issuedAt"
                    [ngClass]="{ 'is-invalid': f.submitted && issuedAt.invalid }" required maxlength="50"
                    [placeholder]="'form.issued_by' | translate">
                  <button mat-button *ngIf="enterprises.issuedAt" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.issuedAt=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted && issuedAt.invalid">
                    <span *ngIf="issuedAt?.errors?.required" class="text-error">{{'validation.issued_by' |
                      translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4"
                *ngIf="enterprises.enterpriseType != personalId || enterprises.enterpriseType == null">
                <mat-form-field class="w-100">
                  <input
  (focusout)="enterprises.taxCode = enterprises.taxCode == undefined ? '' : (enterprises.taxCode + '').trim()"
  matInput autocomplete="off" id="taxCodeId" type="text" name="taxCode" #taxCode="ngModel"
  [(ngModel)]="enterprises.taxCode" [maxlength]="taxCodeMaxlength"
  [placeholder]="'form.tax_code' | translate" [disabled]="checkTax" required maxlength="20">
                  <button mat-button *ngIf="enterprises.taxCode" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.taxCode=''" [disabled]="checkTax">
                    <mat-icon>close</mat-icon>
                  </button>
                  <!-- <mat-error *ngIf="f.submitted && taxCode.invalid">
                    <span *ngIf="taxCode?.errors?.validIp " class="text-error">{{'validation.tax_code_number' |
                      translate}}</span>
                  </mat-error> -->
                  <mat-error *ngIf="f.submitted && taxCode.invalid">
                    <span *ngIf="taxCode?.errors?.duplicate"
                      class="text-error">{{'update_enterprise.validation.lbl_validation_tax_code_duplicate' |
                      translate}}</span>
                  </mat-error>
                  <mat-error *ngIf="f.submitted && taxCode?.errors?.required">
                    {{'validation.code_tax_request' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel *ngIf="enterprises.enterpriseType != personalId || enterprises.enterpriseType == null">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
                {{'title.representative_info' | translate}}
                <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                  translate}}
                </small>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.representative = enterprises.representative == undefined ? '' : (enterprises.representative + '').trim()"
                    matInput autocomplete="off" type="text" name="representative" #representative="ngModel"
                    [(ngModel)]="enterprises.representative" required maxlength="200"
                    [ngClass]="{ 'is-invalid': f.submitted && representative.invalid }"
                    [placeholder]="'form.full_name' | translate">
                  <button mat-button *ngIf="enterprises.representative" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.representative=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || representative.invalid">
                    <span *ngIf="representative?.errors?.required" class="text-error">{{'validation.representative' |
                      translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.position = enterprises.position == undefined ? '' : (enterprises.position + '').trim()"
                    matInput autocomplete="off" type="text" name="position" #position="ngModel"
                    [(ngModel)]="enterprises.position" [ngClass]="{ 'is-invalid': f.submitted && position.invalid }"
                    required maxlength="200" [placeholder]="'form.position' | translate">
                  <button mat-button *ngIf="enterprises.position" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.position=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || position.invalid">
                    <span *ngIf="position?.errors?.required" class="text-error">{{'validation.position' |
                      translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.type_certification' | translate}}</mat-label>
                  <mat-select #representativeCertificateSelect (focusout)="(checkFocus = true)"
                    (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, representativeCertificateSelect)"
                    id="representativeCertificateId" name="representativeCertificateId"
                    [(ngModel)]="enterprises.representativeCertificateId"
                    value="enterprises.representativeCertificateId">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate"
                        [formControl]="representativeCertificateTypeFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let representativeCertificateType of filteredRepresentativeCertificateType | async"
                      [value]="representativeCertificateType.id"
                      (click)="this.commonService.closeDropdownList(this.representativeCertificateSelect)">
                      {{getEnterpriseTypeOptions(representativeCertificateType.langs)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.representativeCertificateNo = enterprises.representativeCertificateNo == undefined ? '' : (enterprises.representativeCertificateNo + '').trim()"
                    matInput autocomplete="off" type="text" name="representativeCertificateNo"
                    [(ngModel)]="enterprises.representativeCertificateNo" #representativeCertificateNo="ngModel"
                    maxlength="20" appCheckSpace [placeholder]="'form.certification_no' | translate">
                  <button mat-button *ngIf="enterprises.representativeCertificateNo" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.representativeCertificateNo=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || representativeCertificateNo.invalid">
                    <span *ngIf="representativeCertificateNo?.errors?.validInput" class="text-error">
                      {{'validation.gpkd_format' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="representativeIssuedDate1" [max]="maxDate"
                    (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['representativeIssuedDate'])"
                    name="representativeIssuedDate" [(ngModel)]="enterprises.representativeIssuedDate"
                    #representativeIssuedDate="ngModel" maxlength="10" #pickerInput1 (dateInput)="addEvent($event)"
                    (dateChange)="addEvent($event)" [placeholder]="'form.issued_date' | translate">
                  <mat-datepicker-toggle matSuffix [for]="representativeIssuedDate1"></mat-datepicker-toggle>
                  <mat-datepicker #representativeIssuedDate1></mat-datepicker>
                  <mat-error *ngIf="f.submitted || representativeIssuedDate.invalid">
                    <span class="text-error">
                      {{getErrorDateMessage(pickerInput1.value)}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.representativeIssuedOn = enterprises.representativeIssuedOn == undefined ? '' : (enterprises.representativeIssuedOn + '').trim()"
                    matInput type="text" name="representativeIssuedOn" [(ngModel)]="enterprises.representativeIssuedOn"
                    maxlength="200" [placeholder]="'form.issued_by' | translate">
                  <button mat-button *ngIf="enterprises.representativeIssuedOn" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.representativeIssuedOn=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="birthday1" name="birthday" [max]="maxDate"
                    (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['birthday'])"
                    [(ngModel)]="enterprises.birthday" #birthday=ngModel #pickerInput2 maxlength="10"
                    (dateInput)="addEvent($event)" (dateChange)="addEvent($event)"
                    [placeholder]="'form.birthday' | translate" />
                  <mat-datepicker-toggle matSuffix [for]="birthday1"></mat-datepicker-toggle>
                  <mat-datepicker #birthday1></mat-datepicker>
                  <mat-error *ngIf="f.submitted || birthday.invalid">
                    <span class="text-error">
                      {{getErrorDateMessage(pickerInput2.value)}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-label style="color: #858796">{{'form.sex' | translate}}</mat-label><br>
                <mat-radio-group #sexSelect2 id="sex" name="sex" [(ngModel)]="enterprises.sex">
                  <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                  <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
                {{'title.contact_info' | translate}}
                <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                  translate}}
                </small>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row font-weight-bold">
              <div class="col-12">
                <div class="d-flex align-items-center">
                  <div style="font-size: 15px; color:#000000DE" class="">{{'form.use_new_area' | translate}}</div>
                  <div class="d-flex pl-2">
                    <div (click)="changeAddress(true)"
                      [ngClass]="enterprises.addresses[0].isNewAddress ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                      {{'user_group.on_document' | translate}}</div>
                    <div (click)="changeAddress(false)"
                      [ngClass]="!enterprises.addresses[0].isNewAddress ? 'status-document' : 'text-off-document'"
                      style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                      {{'user_group.off_document' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.city' | translate}}</mat-label>
                  <mat-select #citySelect (focusout)="(checkFocus = true)"
                    (focus)="commonService.openComboBox(checkFocus, citySelect)" id="cityId" name="cityId" id="cityId"
                    #cityId="ngModel" (selectionChange)="checkFocus = false; onChange($event.value, enterprises.addresses[0].isNewAddress ? 2: 1);" required
                    [(ngModel)]="enterprises.addresses[0].cityId"
                    [ngClass]="{ 'is-invalid': f.submitted && cityId.invalid }">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="cityFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let city of filteredCity | async" [value]="city.id"
                      (click)="this.commonService.closeDropdownList(this.citySelect)" mat-selected>{{city.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || cityId.invalid">
                    <span *ngIf="cityId?.errors?.required" class="text-error">{{'validation.city' | translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4" *ngIf="!enterprises.addresses[0].isNewAddress">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.district' | translate}}</mat-label>
                  <mat-select #districtSelect (focusout)="(checkFocus = true)"
                    (focus)="commonService.openComboBox(checkFocus, districtSelect)" id="districtId" name="districtId"
                    [(ngModel)]="enterprises.addresses[0].districtId" #districtId="ngModel" required
                    [ngClass]="{ 'is-invalid': f.submitted && districtId.invalid }"
                    (selectionChange)="checkFocus = false; onChange($event.value, 2);">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="districtsFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let district of filteredDistricts | async" [value]="district.id"
                      (click)="this.commonService.closeDropdownList(this.districtSelect)">
                      {{ district.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || districtId.invalid">
                    <span *ngIf="districtId?.errors?.required" class="text-error">{{'validation.district' |
                      translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <ng-container *ngIf="notHasWard; else hasWard">
                  <mat-form-field class="w-100">
                    <mat-label>{{'form.ward' | translate}}</mat-label>
                    <mat-select (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                      (focus)="commonService.openComboBox(checkFocus, wardSelect1)" id="wardId" #wardSelect1
                      name="wardId" [(ngModel)]="enterprises.addresses[0].wardId" #wardId="ngModel">
                      <mat-option>
                        <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                          [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                      <mat-option *ngFor="let ward of filteredWard | async" [value]="ward.id">
                        {{ ward.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
                <ng-template #hasWard>
                  <mat-form-field class="w-100">
                    <mat-label>{{'form.ward' | translate}}</mat-label>
                    <mat-select #wardSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                      (focus)="commonService.openComboBox(checkFocus, wardSelect)" id="wardId" name="wardId"
                      [(ngModel)]="enterprises.addresses[0].wardId" #wardId="ngModel" required
                      [ngClass]="{ 'is-invalid': f.submitted && wardId.invalid }">
                      <mat-option>
                        <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                          [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                      <mat-option *ngFor="let ward of filteredWard | async" [value]="ward.id"
                        (click)="this.commonService.closeDropdownList(this.wardSelect)">
                        {{ ward.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.submitted || wardId.invalid">
                      <span *ngIf="wardId?.errors?.required" class="text-error">{{'validation.ward' | translate}}</span>
                    </mat-error>
                  </mat-form-field>
                </ng-template>
              </div>
            
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.addresses[0].address = enterprises.addresses[0].address == undefined ? '' : (enterprises.addresses[0].address + '').trim()"
                    matInput type="text" name="address" #address="ngModel"
                    [(ngModel)]="enterprises.addresses[0].address"
                    [ngClass]="{ 'is-invalid': f.submitted && address.invalid }" required maxlength="200"
                    [placeholder]="'headertable.address' | translate">
                  <button mat-button *ngIf="enterprises.addresses[0].address" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.addresses[0].address=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || address.invalid">
                    <span *ngIf="address?.errors?.required" class="text-error">{{'validation.address' |
                      translate}}</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.phone = enterprises.phone == undefined ? '' : (enterprises.phone + '').trim()"
                    matInput autocomplete="off" type="text" name="phoneNumber" #phoneNumber="ngModel"
                    [(ngModel)]="enterprises.phone" required [ngClass]="{ 'is-invalid': f.submitted && phoneNumber.invalid }"
                    [maxlength]="maxLengthPhone" [placeholder]="'search_form.phone' | translate" [pattern]="phonePattern2">
                  <button mat-button *ngIf="enterprises.phone" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.phone=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || phoneNumber.invalid">
                    <span *ngIf="phoneNumber?.errors?.required" class="text-error">{{'validation.phone_number_re' |
                      translate}}</span>
                    <span *ngIf="phoneNumber?.errors?.pattern" class="text-error">{{'validation.phone_format_upgrade' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.email' | translate}}</mat-label>
                  <input
                    (focusout)="enterprises.email = enterprises.email == undefined ? '' : (enterprises.email + '').trim()"
                    matInput autocomplete="off" type="text" name="email" [(ngModel)]="enterprises.email"
                    #email="ngModel" required [pattern]="emailPattern" [maxlength]="emailMaxlength"
                    [placeholder]="'placeholder.email' | translate" />
                  <button mat-button *ngIf="enterprises.email" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.email=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || email.invalid">
                    <span *ngIf="email?.errors?.required" class="text-error">
                      {{'validation.email' | translate}}
                    </span>
                    <span *ngIf="email?.errors?.pattern" class="text-error">{{'validation.email_format' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            
              <div class="col-md-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.fax = enterprises.fax == undefined ? '' : (enterprises.fax + '').trim()"
                    matInput type="text" name="fax" [(ngModel)]="enterprises.fax" #fax="ngModel" maxlength="20"
                    [placeholder]="'form.fax' | translate">
                  <button mat-button *ngIf="enterprises.fax" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="enterprises.fax=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || fax.invalid">
                    <span *ngIf="fax?.errors?.validInput" class="text-error">{{'validation.fax_format' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
                {{'title.pay_info' | translate}}
                <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                  translate}}
                </small>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.accountNumber = enterprises.accountNumber == undefined ? '' : (enterprises.accountNumber + '').trim()"
                    matInput type="text" name="accountNumber" [(ngModel)]="enterprises.accountNumber"
                    [maxlength]="accountNumberMaxlength" #accountNumber="ngModel"
                    [placeholder]="'form.accnumber' | translate">
                  <button mat-button *ngIf="enterprises.accountNumber" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.accountNumber=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || accountNumber?.invalid || accountNumber?.errors?.validIp">
                    {{'validation.account_number' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.accountName = enterprises.accountName == undefined ? '' : (enterprises.accountName + '').trim()"
                    matInput type="text" name="accountName" [(ngModel)]="enterprises.accountName"
                    [maxlength]="accountNameMaxlength" [placeholder]="'form.accountName' | translate">
                  <button mat-button *ngIf="enterprises.accountName" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.accountName=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <!-- <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.bankName = enterprises.bankName == undefined ? '' : (enterprises.bankName + '').trim()"
                    matInput type="text" name="bankName" [(ngModel)]="enterprises.bankName" [maxlength]="bankMaxlength"
                    [placeholder]="'form.bank' | translate">
                  <button mat-button *ngIf="enterprises.bankName" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.bankName=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field> -->

                <mat-form-field class="w-100">
                  <mat-select #bankSelect (focusout)="(checkFocus = true)"
                    (focus)="commonService.openComboBox(checkFocus, bankSelect)" id="focusSelect" name="type"
                    (selectionChange)="checkFocus = false;"
                    [(ngModel)]="enterprises.bankName" #type="ngModel"
                    [placeholder]="'form.bank' | translate"
                  >
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="bankFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let bankName of filteredBankName | async" [value]="bankName.key"
                      (click)="this.commonService.closeDropdownList(this.bankSelect)"
                      title="{{bankName.value}}">
                      {{bankName.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="enterprises.bankBranch = enterprises.bankBranch == undefined ? '' : (enterprises.bankBranch + '').trim()"
                    matInput type="text" name="bankBranch" [(ngModel)]="enterprises.bankBranch"
                    [maxlength]="bankMaxlength" [placeholder]="'search_form.branch' | translate">
                  <button mat-button *ngIf="enterprises.bankBranch" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="enterprises.bankBranch=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <!-- <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title">
                {{'update_enterprise.attach.ttl_attach' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-upload-multi-file (hasChange)="onAttachmentChange($event)"
              [arrAttachments]="this.enterprises.attachments"></app-upload-multi-file>
            <mat-hint class="hint-text">
              {{'hint.attach_accept_pdf_image' | translate}}
            </mat-hint>
          </mat-expansion-panel> -->
        </mat-accordion>
      </mat-card-content>

      <mat-card-actions class="text-center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" type="submit" [disabled]="!isFormChanging">
          <mat-icon class="mr-0">save</mat-icon>
          {{'kyc.save_identify' | translate}}
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>


<!-- Footer -->
<app-landingpage-footer></app-landingpage-footer>
<!-- End of Footer -->